import { render, staticRenderFns } from "./MarsDATA.vue?vue&type=template&id=51af7eb0&scoped=true&"
import script from "./MarsDATA.vue?vue&type=script&lang=js&"
export * from "./MarsDATA.vue?vue&type=script&lang=js&"
import style0 from "./MarsDATA.vue?vue&type=style&index=0&id=51af7eb0&lang=scss&scoped=true&"
import style1 from "./MarsDATA.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51af7eb0",
  null
  
)

export default component.exports